module.exports = __webpack_public_path__ + "assets/images/artist3.026e4277.jpg";